import {getRequest, postRequest, postRequestFile} from "../fetchWrapper";

/**
 * Lecture de la liste des courriers après décès.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCADList = (token, pageNumber, itemsPerPage) => {
    const url = `/api-v1/admin/cad/${pageNumber}/${itemsPerPage}/list`;
    return getRequest(url, token)
}

/**
 * Lecture des informations d'un courrier après décès.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant du courrier après décès.
 */
export const getCADInfos = (token, id) => {
    const url = `/api-v1/admin/cad/${id}/infos`;
    return getRequest(url, token)
}

/**
 * Création de la vue d'un courrier après décès.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant du courrier après décès.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCADView = (token, body) => {
    const url = `/api-v1/admin/cad/view`;
    return postRequestFile(url, body, token)
};

/**
 * Mise à jour des informations d'un courrier après décès.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Données du courrier après décès.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateCADInfos = (token, body) => {
    const url = `/api-v1/admin/cad/infos`;
    return postRequest(url, body, token)
};

/**
 * Modification de la visibilité d'un courrier.
 *
 * @param string $token Jeton d'authentification.
 * @param object body Informations du courrier à modifier.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const setCADEnabled = (token, body) => {
    const url = `/api-v1/admin/cad/enable`
    return postRequest(url, body, token)
};

/**
 * Suppression d'un courrier.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant du réseau.
 * @return Response | null Réponse de la requête à l'API.
 */
export const deleteCadFromDb = (token, id) => {
    const url = `/api-v1/admin/cad/delete`
    return postRequest(url, id, token)
};